<template>
  <h1>{{title}}</h1>
</template>

<script>
export default {
  props: ['title']
}
</script>

<style scoped>
h1 {
  color: default;
}
</style>



// WEBPACK FOOTER //
// src/components/Shared/PageTitle.vue